import Layout from "@/layouts/default/main"
export default {
    path: "/dashboard",
    redirect: "/dashboard/index",
    name: "Dashboard",
    component: Layout,
    children: [{
        path: "index",
        name: "DashboardIndex",
        component: () => import("@/views/dashboard/index")
    }]
}